var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequestMic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.668 16.5117C14.1557 16.5117 16.1797 14.4878 16.1797 12V5.51172C16.1797 3.02396 14.1557 1 11.668 1C9.18021 1 7.15625 3.02396 7.15625 5.51172V12C7.15625 14.4878 9.18021 16.5117 11.668 16.5117Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1133 10.0664C17.7573 10.0664 17.4688 10.355 17.4688 10.7109V12C17.4688 15.1986 14.8665 17.8008 11.668 17.8008C8.46942 17.8008 5.86719 15.1986 5.86719 12V10.7109C5.86719 10.355 5.57861 10.0664 5.22266 10.0664C4.8667 10.0664 4.57812 10.355 4.57812 10.7109V12C4.57812 15.6921 7.41505 18.7335 11.0234 19.0602V21.7109H7.80078C7.44483 21.7109 7.15625 21.9995 7.15625 22.3555C7.15625 22.7114 7.44483 23 7.80078 23H15.5352C15.8911 23 16.1797 22.7114 16.1797 22.3555C16.1797 21.9995 15.8911 21.7109 15.5352 21.7109H12.3125V19.0602C15.9209 18.7335 18.7578 15.6921 18.7578 12V10.7109C18.7578 10.355 18.4692 10.0664 18.1133 10.0664Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22266 7.48828C5.57861 7.48828 5.86719 7.1997 5.86719 6.84375V3.62109C5.86719 3.26514 5.57861 2.97656 5.22266 2.97656C4.8667 2.97656 4.57812 3.26514 4.57812 3.62109V6.84375C4.57812 7.1997 4.8667 7.48828 5.22266 7.48828Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64453 1C2.28858 1 2 1.28858 2 1.64453V8.77734C2 9.1333 2.28858 9.42188 2.64453 9.42188C3.00048 9.42188 3.28906 9.1333 3.28906 8.77734V1.64453C3.28906 1.28858 3.00048 1 2.64453 1Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1133 2.97656C17.7573 2.97656 17.4688 3.26514 17.4688 3.62109V6.84375C17.4688 7.1997 17.7573 7.48828 18.1133 7.48828C18.4692 7.48828 18.7578 7.1997 18.7578 6.84375V3.62109C18.7578 3.26514 18.4692 2.97656 18.1133 2.97656Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6914 1C20.3355 1 20.0469 1.28858 20.0469 1.64453V8.77734C20.0469 9.1333 20.3355 9.42188 20.6914 9.42188C21.0474 9.42188 21.3359 9.1333 21.3359 8.77734V1.64453C21.3359 1.28858 21.0474 1 20.6914 1Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestMic);
export default __webpack_public_path__ + "static/media/request-mic.f8975548.svg";
export { ForwardRef as ReactComponent };